'use client';

import { useNuqsNextPagesRouterAdapter } from '../../chunk-6OWCDW4K.js';
import '../../chunk-QHW6KBHR.js';
import '../../chunk-3RCMAOX7.js';
import { createAdapterProvider } from '../../chunk-DASHEO2X.js';

// src/adapters/next/pages.ts
var NuqsAdapter = createAdapterProvider(useNuqsNextPagesRouterAdapter);

export { NuqsAdapter };
